import api from '@/api/api_domain'
/**
 * Created by yqr on 2018/4/25.
 */

// 调多个域公用方法
// 示例 created里添加以下代码
// let domainKeys = 'purchaseConType,areaResources';  //域名字符串逗号隔开
// let arrNames = ['statusList','areaList'];   //域名对应的接收数组名组成的数组传值
// this.$Utils.getDomainKeys(domainKeys,arrNames,this); 
export async function getDomainKeys(domainKeys,arrNames,that) {
	let params = {
		keyList:domainKeys,
	};
	let res = await that.$api.domain.getDomainKeysReturnMapRedis(params);
	let data = res.data.data;
	var domainList= domainKeys.split(",");
	for(var i = 0 ; i < domainList.length ; i++ ){
		that[arrNames[i]] = data[domainList[i]].listDomainDefine;
	}
}

//表格公用方法
// 示例 :formatter="(row)=>$Utils.tableFormatter(row,'contractApptype','contractOrderTypeList',this)"   contractApptype当前字段名，contractOrderTypeList 当前域列表数组
export function tableFormatter(row,rowParam,paramList,that) {
	for(var a = 0 ;a< that[paramList].length ; a++){
	  if(row[rowParam] == that[paramList][a].value){
      if(paramList =='calParaList' && row['costCode'] && (row['costCode'] == '2212' || row['costCode'] == '2213')){
        return '配送入库金额'
      }else{
        return that[paramList][a].name;
      }
	  }
	}
	return row[rowParam];
}


// WEBPACK FOOTER //
// ./src/common/common.js